/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import {
	ModelOfVehicleItem,
	ModelOfCategory,
	ModelOfBrand,
	ModelOfMileage,
	ModelOfStock,
	ModelOfFuelType,
	ModelOfVehicleItemForm,
	ModelOfStatus,
	ModelOfEspecie,
} from '../../database/index';

import api from 'src/services/api';
import { AxiosResponse } from 'axios';
import { useData } from 'src/contexts/data';
import { useUploadController } from '../ImageUpload/UploadController';
import { useAuth } from 'src/contexts/auth';

export const useFormCreateVehicle = () => {
	const { handleUpload } = useUploadController();
	const { imageUploading } = useData();

	const { userAgencyId } = useAuth();

	const [formDialog, setFormDialog] = useState(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [stocksData, setStocksData] = useState<ModelOfStock[]>([]);
	const [brandsData, setBrandsData] = useState<ModelOfBrand[]>([]);
	const [statusData, setStatusData] = useState<ModelOfStatus[]>([]);
	const [mileagesData, setMileagesData] = useState<ModelOfMileage[]>([]);
	const [fuelTypesData, setFuelTypesData] = useState<ModelOfFuelType[]>([]);
	const [categoriesData, setCategoriesData] = useState<ModelOfCategory[]>([]);
	const [especiesData, setEspeciesData] = useState<ModelOfEspecie[]>([]);
	const [vehicleResponse, setVehicleResponse] = useState<AxiosResponse | null>(null);
	const [vehicleEditedResponse, setVehicleEditedResponse] = useState<AxiosResponse | null>(null);
	const [selectedField, setSelectedField] = useState('');

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		AX_ESTOQUE: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		PLACA: Yup.string().required('* Campo obrigatório'),
		//DESCRICAO: Yup.string().required('* Campo obrigatório'),
		//SIGLA: Yup.string().required('* Campo obrigatório'),
		//MARCADORKM: Yup.string().required('* Campo obrigatório'),
		COR: Yup.string().required('* Campo obrigatório'),
		//ANOFABRICACAO: Yup.string().required('* Campo obrigatório'),
		//ANOMODELO: Yup.string().optional(),
		//FT_CATEGORIA: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		//CERTIFICADOREGISTRO: Yup.string().optional(),
		//CAPCIDADEPOTENCIACILINDRADA: Yup.string().optional(),
		//NUMEROCHASSI: Yup.string().optional(),
		//NUMEROMOTOR: Yup.string().nullable(),
		//CAPACIDADECOMBUSTIVEL: Yup.string().optional(),
		//RENAVAM: Yup.string().optional(),
		//ANOLICENCIADO: Yup.string().required('* Campo obrigatório'),
		//FT_TIPOQUILOMETRAGEM: Yup.string().optional(),
		//FT_MARCA: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		TIPOCOMBUSTIVEL: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
		STATUS: Yup.number().required('* Campo obrigatório. Selecione uma opção da lista'),
		//FT_ESPECIE: Yup.string().optional(), 
	}); 

	const getCategories = async () => {
		const response = await api.get(`categorys/${userAgencyId}`);

		setCategoriesData(response.data);
	};
	const getEspecies = async () => {
		const response = await api.get(`especies/${userAgencyId}`);

		setEspeciesData(response.data);
	};
	const getStocks = async () => {
		const response = await api.post(`/stocks/${userAgencyId}`);

		setStocksData(response.data);
	};
	const getBrands = async () => {
		const response = await api.get(`brands/${userAgencyId}`);

		setBrandsData(response.data);
	};
	const getMileages = async () => {
		const response = await api.get(`mileages/${userAgencyId}`);

		setMileagesData(response.data);
	};
	const getFueltypes = async () => {
		const response = await api.get(`/fuels/${userAgencyId}`);

		setFuelTypesData(response.data);
	};
	const getStatus = async () => {
		const response = await api.get('status');

		setStatusData(response.data);
	};

	useEffect(() => {
		getCategories();
		getBrands();
		getMileages();
		getStocks();
		getFueltypes();
		getStatus();
		getEspecies();
	}, []);

	const saveVehicles = async (values: ModelOfVehicleItem) => {
		setLoading(true);
		console.log("Inicio do cadastro")
		const newVehicle: ModelOfVehicleItemForm = {
			...values,
			CAPACIDADECOMBUSTIVEL: parseFloat(values.CAPACIDADECOMBUSTIVEL?.replace(',', '.')),
			MARCADORKM: parseFloat(values.MARCADORKM?.replace(',', '.')),
		};

		if (!!vehicleResponse) {
			console.log("Inicio do cadastro 1111")
			
			api.put(`vehicles/${vehicleResponse.data?.ID}`, newVehicle)
				.then(response => {
					formik.resetForm();
					setVehicleResponse(null);
					setVehicleEditedResponse(response);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O veículo foi editada com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			console.log("Inicio do cadastro 222")
			console.log(newVehicle)
			api.post('vehicles', newVehicle)
				.then(response => {
					setVehicleResponse(response);
					setVehicleEditedResponse(null);
					setLoading(false);
					handleUpload.processUploadFileImage(imageUploading, 'docveiculo', 'FT_VEICULO', response.data.ID);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Operação realizada com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const openFormDialog = async (field: string) => {
		setFormDialog(true);
		setSelectedField(field);
	};

	const closeFormDialog = () => {
		setFormDialog(false);
		setSelectedField('');
	};

	const formik = useFormik<ModelOfVehicleItem>({
		initialValues: {
			AX_ESTOQUE: '',
			PLACA: '',
			DESCRICAO: '',
			SIGLA: '',
			MARCADORKM: '',
			COR: '',
			ANOFABRICACAO: 0,
			ANOMODELO: 0,
			FT_CATEGORIA: '',
			CERTIFICADOREGISTRO: '',
			CAPCIDADEPOTENCIACILINDRADA: '',
			NUMEROCHASSI: '',
			NUMEROMOTOR: '',
			CAPACIDADECOMBUSTIVEL: '',
			RENAVAM: '',
			ANOLICENCIADO: 0,
			FT_TIPOQUILOMETRAGEM: '',
			FT_MARCA: '',
			TIPOCOMBUSTIVEL: {
				ID: [],
			},
			ORGAOUNIDADE: '',
			STATUS: 1,
			FT_ESPECIE: '',
		},
		onSubmit: async values => await saveVehicles(values),
		validationSchema,
	});

	return {
		getFormController: {
			formik,
			loading,
			formDialog,
			selectedField,
			toast,
			vehicleResponse,
			vehicleEditedResponse,
			tablesData: {
				categoriesData: categoriesData,
				stocksData: stocksData,
				brandsData: brandsData,
				mileagesData: mileagesData,
				fuelTypesData: fuelTypesData,
				statusData: statusData,
				especiesData: especiesData,
			},
		},
		handleFormController: {
			openFormDialog,
			closeFormDialog,
			getBrands,
			getCategories,
			getStocks,
			getMileages,
			getFueltypes,
			setVehicleResponse,
		},
	};
};
